<div 
   class="gov-form-control"
   [class.not-empty]="isOpen() || isControlFilled()">
   <div class="gov-select">
    <input type="text" 
            class="gov-form-control__input" 
            autocomplete="off"
            [id]="filterItem()!.column"
            [placeholder]="placeholder()"
            [value]="searchText()"
            (input)="onInput($event)"
            (focus)="openDropdown()">
    @if (filterItem()!.label) {
        <label class="gov-form-control__label filterLabel" [for]="filterItem()!.column">{{ filterItem()!.label | localize }}</label>
    }
   </div>
           
    @if (isOpen()) {
        <ul class="gov-multiselect__options">
            @for (option of filteredOptions(); track option.value) {
                <li class="gov-multiselect__option" (click)="selectOption(option)">{{ option.text }}</li>
            }
        </ul>
    }
</div>